import { useState, useEffect, Fragment } from 'react'
import { gql } from '@apollo/client'
import { Input, Table, Alert } from 'reactstrap'
import { isDisabled, handleGraphQLErrors } from '../../utils'
import { JOURNAL_ENTRIES_QUERY } from '../../graphql.js'

const JOURNAL_ENTRIES = gql(JOURNAL_ENTRIES_QUERY)

export default function AppObjectFieldJournal(props) {
  const { objectId, field, action, value, handleChange, hasChanged } =  props
  console.log('AppObjectFieldJournal rendered: ', props)

  const [text, setText] = useState(value)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [items, setItems] = useState([])


  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: JOURNAL_ENTRIES, variables: { fieldId: field.id, objectId: objectId } })
        if (data.journalEntries) {
          const rows = []
          let key = 0
          for (let journalEntry of data.journalEntries) {
            let row = 
              <tr key={key++}>
                <td style={{ whiteSpace: 'pre-wrap'}}>
                  <b>Date:</b> {journalEntry.created}&nbsp;&nbsp;<b>Author:</b> {journalEntry.createdBy.name}
                  <br /><br />
                  {journalEntry.note}
                </td>
              </tr>
            rows.push(row)
          }
          setItems(rows)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    fetchItems()
  }, [field, objectId])

  function handleTextChange(event) {
    setText(event.target.value)
    handleChange(event, hasChanged)
  }

  let journalEntriesTable = ''
  if (items.length > 0) {
    journalEntriesTable = 
      <Table bordered size="sm">
        <tbody className="ref-list-table-body">
          {items}
        </tbody>
      </Table>
  }
  
  let textInput = ''
  if (!isDisabled(action, field.behaviorType)) {
    textInput =
    <Input
      data-cy={`field-${field.id}`}
      type="textarea"
      name={field.id}
      bsSize="sm"
      id={field.id}
      value={text}
      onChange={(event) => handleTextChange(event)}
      rows={field.height}
      cols={field.width}
    />
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  return (
    <Fragment>
      {textInput}
      {journalEntriesTable}
    </Fragment>
  )
}
